// extracted by mini-css-extract-plugin
export default {"root":"TipStuList_root__Npbkl","overlay":"TipStuList_overlay__1ZEP4","item":"TipStuList_item__AZqW4","num":"TipStuList_num__eTQ+y"};